import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'accounts/min-app-version';

export const MIN_APP_VERSION_ENDPOINTS = {
  retrieveMinAppVersion: formatEndpoint('', namespace),
};
